import React from 'react';
import PropTypes from 'prop-types';
import SignaturesSelect from '../Shared/SignaturesSelect';

const LineSelect = ({
  prospects, prospectsLines, maxSignatures, onChange,
}) => (
  <>
    {prospects.map((prospect) => (
      <SignaturesSelect
        key={prospect.id}
        ignoreValues={Object.values(prospectsLines)}
        value={prospectsLines[prospect.id] || 0}
        maxSignatures={maxSignatures}
        onChange={(value) => onChange(prospect.id, Number(value))}
        label={`${prospect.first_name} ${prospect.last_name}`}
      />
    ))}
  </>
);

LineSelect.propTypes = {
  prospects: PropTypes.arrayOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  prospectsLines: PropTypes.object.isRequired,
  maxSignatures: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LineSelect;
